export default defineNuxtRouteMiddleware((to) => {
    const config = useRuntimeConfig();
    const requiredToken = getRequiredToolsToken(to.path, config.public);

    if (requiredToken && to.query.token !== requiredToken) {
        return navigateTo('/');
    }
});

function getRequiredToolsToken(
    path: string,
    publicConfig: ReturnType<typeof useRuntimeConfig>['public'],
) {
    switch (true) {
        case path.includes('/tools/product-preset-configurator'):
            return publicConfig.productPresetToolToken;

        case path.includes('/tools/product-config-preset-configurator'):
        case path.includes('/tools/preset-configurator'):
            return publicConfig.productConfigPresetToolToken;

        default:
            return publicConfig.productConfigPresetToolToken;
    }
}
